<template>
    <vPartnerCurrentLineComponent :postList="postList" v-if="flag"></vPartnerCurrentLineComponent>
</template>
<script>
import vPartnerCurrentLineComponent from '../../listComponent/basicdata/partnerCurrentLine/partnerCurrentLineComponent.vue';
export default {
    name: 'account',
    components: {
        vPartnerCurrentLineComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                updateBtn: true,
                uploadBtn: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                rid: true,
                partner_current_rid: true,
                approval_status: true,
                date: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>